/* eslint-disable react/prop-types */
import React from 'react';

import BaseModal from './Base';

export const MODAL_SIZE = {
    SMALL: 'small',
    NORMAL: 'normal',
    LARGE: 'large',
};

const Modal = props => {
    const { children, modalProps } = props;
    return <BaseModal {...modalProps}>{children}</BaseModal>;
};

export default Modal;
